import { useEffect, useRef } from 'react';
import PrimaryButton from '../Common/PrimaryButton';
import SecondaryButton from '../Common/SecondaryButton';

interface Props {
  isOpen: boolean;
  name: string;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const VerifyModal: React.FC<Props> = ({
  isOpen,
  name,
  isLoading = false,
  onCancel,
  onConfirm,
}) => {
  const modal = useRef<HTMLDivElement>(null);

  // Close on Escape key while the modal is open.
  useEffect(() => {
    if (!isOpen) return;
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className='fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5'>
      <div
        ref={modal}
        className='w-full max-w-142.5 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:px-8 md:py-12'
      >
        <h3 className='pb-2 text-left text-xl font-bold text-black dark:text-white sm:text-2xl'>
          Verify Professional
        </h3>
        <p className='text-left'>
          You are about to verify <span className='font-bold'>{name}</span>.
          Doing so will legitimize them in the database and confirm all
          information entered here allowing their record to show up for
          patients.
        </p>
        <br />
        <p className='mb-10 text-left'>Are you sure you want verify them?</p>
        <div className='-mx-3 flex flex-wrap gap-y-4'>
          <div className='mx-3'>
            <SecondaryButton onClick={onCancel} title='Cancel' />
          </div>
          <div>
            <PrimaryButton
              onClick={isLoading ? undefined : onConfirm}
              title={isLoading ? 'Verifying…' : 'Verify'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyModal;
